import {Box} from '@mui/material'
import {Moment} from 'moment-timezone'
import React from 'react'

import {LinearScaleFn, TimeScaleFn} from './utils/scale'

interface DatetimeValueChartHoverBarsProps {
  chartWidth: number
  xScale: TimeScaleFn
  yScale: LinearScaleFn
  steps: Moment[]
}

export const DatetimeValueChartHoverBars: React.FC<DatetimeValueChartHoverBarsProps> = ({
  chartWidth,
  xScale,
  yScale,
  steps
}) => {
  const height = yScale(0)

  return (
    <Box
      sx={{
        overflow: 'hidden',
        position: 'absolute',
        top: 0,
        width: chartWidth,
        height
      }}
    >
      <svg height={height} width={chartWidth}>
        {steps.map((datetime, index) =>
          index === steps.length - 1 ? null : (
            <Box
              component="rect"
              key={index}
              x={xScale(datetime.toDate())}
              sx={{
                opacity: 0,
                fill: ({palette}) => palette.primary.light,
                width: xScale(steps[index + 1].toDate()) - xScale(datetime.toDate()),
                height,
                '&:hover': {
                  opacity: 0.1
                }
              }}
            />
          )
        )}
      </svg>
    </Box>
  )
}
